import { escape } from "./__escape";

export default { escape };
